import React from 'react';
import SVGLoader, {
  SVGLoaderProps,
} from '@rsos/base-assets/icons/src/SVGLoader';

const defaults = {
  width: 14,
  height: 14,
  viewboxWidth: 14,
  viewboxHeight: 14,
};

export const ClipboardTextIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}: SVGLoaderProps) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 2.5H5.75C5.05964 2.5 4.5 1.94036 4.5 1.25C4.5 0.559644 5.05964 0 5.75 0H8.25C8.94036 0 9.5 0.559644 9.5 1.25C9.5 1.94036 8.94036 2.5 8.25 2.5ZM5.75 3.75H8.25C9.63071 3.75 10.75 2.63071 10.75 1.25C10.75 1.16563 10.7458 1.08223 10.7377 1H11.5C12.3284 1 13 1.67157 13 2.5V12.5C13 13.3284 12.3284 14 11.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1H3.26234C3.25418 1.08223 3.25 1.16563 3.25 1.25C3.25 2.63071 4.36929 3.75 5.75 3.75ZM3.875 8.00049C3.875 7.65531 4.15482 7.37549 4.5 7.37549H9.5C9.84518 7.37549 10.125 7.65531 10.125 8.00049C10.125 8.34567 9.84518 8.62549 9.5 8.62549H4.5C4.15482 8.62549 3.875 8.34567 3.875 8.00049ZM3.875 10.5005C3.875 10.1553 4.15482 9.87549 4.5 9.87549H9.5C9.84518 9.87549 10.125 10.1553 10.125 10.5005C10.125 10.8457 9.84518 11.1255 9.5 11.1255H4.5C4.15482 11.1255 3.875 10.8457 3.875 10.5005Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default ClipboardTextIcon;
